/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Model, { attr, belongsTo } from '@ember-data/model';
import type ContentReviewRequest from 'embercom/models/content-service/content-review-request';
import type ContentSection from 'embercom/models/content-service/content-section';
import { EntityType } from '../data/entity-types';
import { CAN_MANAGE_KNOWLEDGE_BASE_CONTENT } from 'embercom/lib/knowledge-hub/constants';

export enum RelationshipType {
  INCLUSION = 0,
  CONTRADICTION = 1,
}

export default class ContentSectionRelationship extends Model {
  @attr('number') declare relationshipType: RelationshipType;
  @belongsTo('content-service/content-section', { async: false, inverse: 'outgoingRelationships' })
  declare sourceSection: ContentSection;
  @belongsTo('content-service/content-section', { async: false, inverse: 'incomingRelationships' })
  declare targetSection: ContentSection;

  @belongsTo('content-service/content-review-request', { async: false })
  declare contentReviewRequest: ContentReviewRequest;

  get contentReviewRequests(): ContentReviewRequest[] {
    return [this.contentReviewRequest];
  }

  get isInclusion() {
    return this.relationshipType === RelationshipType.INCLUSION;
  }

  get isContradiction() {
    return this.relationshipType === RelationshipType.CONTRADICTION;
  }

  get entityId() {
    return this.id;
  }

  get entityType() {
    return EntityType.ContentSectionRelationship;
  }

  get requiredEditPermissionForKnowledgeHub() {
    return CAN_MANAGE_KNOWLEDGE_BASE_CONTENT;
  }

  get requiredPublishPermissionForKnowledgeHub() {
    return CAN_MANAGE_KNOWLEDGE_BASE_CONTENT;
  }

  // Hack for suggestion-service.ts L158
  get latestVersion() {
    return null;
  }

  get jsonBlocks() {
    return null;
  }

  get serializedBlocks() {
    return null;
  }

  get title() {
    return '';
  }
}
